export enum HomeLanCodeEnum {
    mlb = 'mlb', // MyLiveBox
    sty = 'sty',
    tv = 'tv',
}

export enum HomeLanServiceStatusEnum {
    AVAILABLE = 'AVAILABLE',
    DISABLED = 'DISABLED',
    NOTSUBSCRIBED = 'NOTSUBSCRIBED',
    RESTRICTED = 'RESTRICTED',
    UNAVAILABLE = 'UNAVAILABLE',
    UNKNOWN = 'UNKNOWN',
    DISCONNECTED = 'DISCONNECTED',
    STANDBY_DEEP = 'STANDBY_DEEP',
    STANDBY_WEAK = 'STANDBY_WEAK',
    ECO_DEEP = 'ECO_DEEP',
    ECO_WEAK = 'ECO_WEAK',
    DEEP = 'DEEP',
    WEAK = 'WEAK',
}

export enum TesterDepannerDomainEnum {
    GP = 'GP',
    SOSH = 'SOSH',
}
